package com.eladfinish.bible.contest.ui.text

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.unit.TextUnit
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.screens.randomVerse.ui.model.toAnnotatedText
import com.eladfinish.bible.contest.text.SpannableStringKMP

fun ChapterData.getAnnotatedString(baseFontSize: TextUnit): AnnotatedString {
    return SpannableStringKMP(
        charSequence = content,
        spannedRangeList = spannedRangeList,
    ).toAnnotatedText(baseFontSize = baseFontSize)
        .annotatedString
}
